import { buildFormErrors, isFormError } from '@lingoda/utils';
import type { FormBag, FormErrors, FormHelper, FormValues } from './_common';

type FormProp<P, V> = P extends object ? FormBag<P, V> : FormHelper<V>;

export const handleFormSubmit =
    <P, V extends FormValues = FormValues>(
        onSubmit: (values: V, form: FormProp<P, V>) => void | Promise<void>,
        onError?: (errors: unknown, values: V, form: FormProp<P, V>) => void | Promise<void>,
        onFinally?: (values: V, form: FormProp<P, V>) => void | Promise<void>,
    ) =>
    async (values: V, form: FormProp<P, V>) => {
        try {
            await onSubmit(values, form);
        } catch (errors) {
            if (isFormError(errors)) {
                form.setErrors(buildFormErrors(errors.messages) as FormErrors<V>);
            }
            await onError?.(errors, values, form);
        } finally {
            await onFinally?.(values, form);
        }
    };
